module.exports = __webpack_public_path__ + "assets/img/sdwan-module1-2.1faa44b2.png";